import React from 'react';

const ArrowRightIcon = ({ color = '#fff' }: { color?: string }): React.ReactElement => (
  <svg
    width={19}
    height={18}
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.0150782 7.704H17.1231L16.2131 8.432L7.89308 0.0599985H10.4931L18.9951 8.64L10.4671 17.22H7.86708L16.2131 8.848L17.1231 9.576H0.0150782V7.704Z"
      fill={color}
    />
  </svg>
);

export default ArrowRightIcon;
